import React from "react"

import AnimatedPage from "../components/AnimatedPage"
import SmoothScrollingButton from "../components/SmoothScrollingButton"
import OurThesis from "../components/aboutus/OurThesis"
import CeoQuote from "../components/aboutus/CeoQuote"
import FoundingTeam from "../components/aboutus/FoundingTeam"
import StorySection from "../components/aboutus/StorySection"
import FeedbackSection from "../components/aboutus/FeedbackSection"


const AboutUs = () => {
    return (
        <AnimatedPage>
            <div className="poppins-font-style about-us-page *">
                <SmoothScrollingButton />
                <React.Fragment className="poppins-font-style *">

                    {/* Our thesis section*/}
                    <OurThesis />

                    {/* The CEO Speaks section*/}
                    <CeoQuote />

                    {/*The Founding Team section*/}
                    <FoundingTeam />

                    {/* Our story section*/}
                    <StorySection />

                    {/* action section*/}
                    <FeedbackSection />
                </React.Fragment>
            </div>
        </AnimatedPage >
    )

}
export default AboutUs



